
























































































































































































































import Vue from "vue";
import { Prop, Component, Emit } from "vue-property-decorator";
// data
import { Furniture, Status } from "@/data/Furniture";
import Physical, { FClass } from "@/data/furniture/Physical";
import Timing from "@/data/furniture/Timing";
import Donor from "@/data/furniture/Donor";
import Attributes from "@/data/furniture/Attributes";
import ViewAction from "@/data/ViewAction";
// components
import PhysicalAttributes from "./FurnitureEditCard/PhysicalAttributes.vue";
import ConditionalDate from "./FurnitureEditCard/ConditionalDate.vue";
import DatePickerMenu from "./DatePickerMenu.vue";
import AttributeQuestions from "./FurnitureEditCard/AttributeQuestions.vue";
import TimingDates from "./FurnitureEditCard/TimingDates.vue";
import ViewActionGroup from "./ViewActionGroup.vue";

@Component({
  components: {
    PhysicalAttributes,
    ConditionalDate,
    DatePickerMenu,
    AttributeQuestions,
    TimingDates,
    ViewActionGroup,
  },
})
export default class FurnitureEditCard extends Vue {
  /* Props */

  @Prop({})
  readonly current!: Furniture;

  @Prop({})
  readonly updates!: Partial<Furniture>;

  @Prop({ default: false })
  readonly readonly!: boolean;

  @Prop({ default: false })
  readonly isEdit!: boolean;

  @Prop({ default: false })
  readonly isAdd!: boolean;

  @Prop({ default: true })
  readonly isStaff!: boolean;

  @Prop({})
  readonly menuActions!: ViewAction[];

  @Prop({ default: false })
  readonly menuLoading!: boolean;

  @Prop({ default: false })
  readonly loading!: boolean;

  /**
   * Sets the offset when user scrolls
   */
  onScroll(e: any): void {
    this.offsetTop = e.target.scrollTop;
  }

  offsetTop = 0;

  /* Form validation */

  valid = true;

  // TODO: consider factoring out validation rules that are reused across the application
  readonly required = [(v: any): boolean | string => !!v || "This is required"];

  readonly emailRules = [
    (v: any): boolean | string => !!v || "This is required",
    (v: any): boolean | string => /.+@.+/.test(v) || "E-mail must be valid",
  ];

  get ACTIONS(): ViewAction[] {
    if (this.readonly) {
      return [{ icon: "close", desc: "Close", emit: "close" }];
    }

    return [
      { icon: "edit", desc: "Edit Item", emit: "edit" },
      {
        icon: "more_vert",
        desc: "More Actions",
        emit: "menu",
        menu: this.menuActions,
        loading: (): boolean => this.menuLoading,
      },
      { icon: "close", desc: "Close", emit: "close" },
    ];
  }

  /** Variables for updates */

  get updatesLength(): number {
    return Object.keys(this.updates).length;
  }

  get currentWithUpdates(): Furniture {
    return { ...this.current, ...this.updates };
  }

  /**
   * Written like this to maintain compatibility with stores
   */
  @Emit("update")
  /* eslint-disable object-curly-newline */
  // eslint-disable-next-line class-methods-use-this
  updateCurrent({
    updates,
  }: {
    updates: Partial<Furniture>;
  }): Partial<Furniture> {
    return updates;
  }
  /* eslint-enable object-curly-newline */

  /* Getters and setters for form fields */

  get donor(): Donor {
    return this.currentWithUpdates.donor || new Donor();
  }

  updateDonor(key: string, value: string): void {
    /* eslint-disable object-curly-newline */
    this.updateCurrent({
      updates: { donor: { ...this.currentWithUpdates.donor, [key]: value } },
    });
    /* eslint-enable */
  }

  get status(): Status {
    return this.currentWithUpdates.status;
  }

  set status(value: Status) {
    this.updateCurrent({ updates: { status: value } });
  }

  readonly statusOptions = Object.values(Status)
    .filter((v) => typeof (v as any) !== "number")
    .map((value, index) => {
      return { text: value, value: index };
    });

  readonly statusIcons = [
    "face",
    "local_shipping",
    "storefront",
    "mood", // could also use "check" or "beenhere"
    "not_listed_location",
  ];

  get fclass(): FClass {
    return this.currentWithUpdates.physical
      ? this.currentWithUpdates.physical.class
      : FClass.Bed;
  }

  set fclass(value: FClass) {
    /* eslint-disable object-curly-newline */
    this.updateCurrent({
      updates: {
        physical: { ...this.currentWithUpdates.physical, class: value },
      },
    });
    /* eslint-enable */
  }

  readonly classOptions = Object.keys(FClass);

  get physical(): Physical {
    return this.currentWithUpdates.physical || new Physical();
  }

  set physical(value: Physical) {
    if (!this.isEdit) return;
    this.updateCurrent({ updates: { physical: value } });
  }

  get timing(): Timing {
    return this.currentWithUpdates.timing || new Timing();
  }

  set timing(value: Timing) {
    this.updateCurrent({ updates: { timing: value } });
  }

  get comments(): string {
    return this.currentWithUpdates.comments;
  }

  get staffNotes(): string {
    return this.currentWithUpdates.staffNotes;
  }

  set staffNotes(value: string) {
    this.updateCurrent({ updates: { staffNotes: value } });
  }

  get attributes(): Attributes {
    return this.currentWithUpdates.attributes || new Attributes();
  }

  set attributes(value: Attributes) {
    this.updateCurrent({ updates: { attributes: value } });
  }

  /**
   * Validates form and emits save if form is valid
   */
  saveChanges(): void {
    const form = this.$refs.editForm as any;
    if (form.validate()) {
      this.$emit("save");
    }
  }
}
